export default __webpack_public_path__ + "static/media/arkguide_02.86786ef0.gif";